import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CadastroVendedorComponent } from './pages/dashboard/cadastro-vendedor/cadastro-vendedor.component';
import { CampanhaComponent } from './pages/dashboard/campanha/campanha.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LembretesComponent } from './pages/dashboard/lembretes/lembretes.component';
import { PainelComponent } from './pages/dashboard/painel/painel.component';
import { PerfilComponent } from './pages/dashboard/perfil/perfil.component';
import { PesquisaClienteComponent } from './pages/dashboard/pesquisa-cliente/pesquisa-cliente.component';
import { EsqueciSenhaComponent } from './pages/login/esqueci-senha/esqueci-senha.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './services/auth.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: PainelComponent },
      { path: 'campanha', component: CampanhaComponent },
      { path: 'busca-cliente', component: PesquisaClienteComponent },
      { path: 'busca-cliente/:cpf', component: PesquisaClienteComponent },
      { path: 'cadastro-vendedor', component: CadastroVendedorComponent },
      { path: 'perfil', component: PerfilComponent },
      { path: 'lembretes', component: LembretesComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
